var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGemIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 12.346 11.2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 0H2.907l.741 2.966L5.625 0zM4.133 3.5h3.825L6.046.63 4.133 3.5zm4.31-.535L9.185 0H6.466l1.977 2.965zM3.235 4.2l1.314 5.253L.045 4.2h3.19zm4.9 0H3.957l1.61 6.441.479.559.479-.559L8.135 4.2zm3.911 0L7.543 9.453 8.857 4.2h3.19zm.046-.7h-3.06L9.813.37l2.277 3.13zM0 3.5L2.277.37 3.06 3.5H0zm12.345.35z",
    fill: "url(#gemIcon_svg__headlinePromoGem)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gemIcon_svg__headlinePromoGem",
    x1: 0.158,
    y1: 5.6,
    x2: 12.346,
    y2: 5.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85C300"
  })))));
}

export default SvgGemIcon;